import {useEffect, useState} from 'react'

/**
 * The reference instant a screen derives the order status from, re-read exactly
 * once: when the cutoff passes. A screen left open across the deadline would
 * otherwise keep showing an order as editable — offering an editor whose every
 * save the server now rejects, or a "Editar pedido" CTA that leads nowhere.
 *
 * A single timeout rather than a ticking interval: nothing derived from the
 * cutoff changes before it is crossed, and each change re-renders the screen.
 *
 * Both order screens use it (the proposal and the detail). Deriving the status
 * from a bare `new Date()` is what this replaces — that reads the clock once per
 * render, so whether the screen ever notices the deadline depends on something
 * else happening to re-render it.
 */
export const useNowAcrossCutoff = (cutoffAt: Date | undefined): number => {
  const [nowMs, setNowMs] = useState(() => Date.now())
  const cutoffMs = cutoffAt?.getTime()

  useEffect(() => {
    if (cutoffMs === undefined) return
    const msUntilCutoff = cutoffMs - Date.now()
    if (msUntilCutoff <= 0) return

    const timeoutId = setTimeout(() => setNowMs(Date.now()), msUntilCutoff + 1)
    return () => clearTimeout(timeoutId)
  }, [cutoffMs])

  return nowMs
}
